import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=6c0b4b1d"
import script from "./InputMoney.vue?vue&type=script&lang=js"
export * from "./InputMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports